import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Loader from "../Loader";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const DCAbottrade = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const botId = location.state?.id || null;
  const path = usercalls();

  const [botDetails, setBotDetails] = useState({});
  const [botLoading, setBotLoading] = useState(false);
  const [botEnabled, setBotEnabled] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [triggerLoading, setTriggerLoading] = useState(false);
  const [openCloseModal, setOpenCloseModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [botStats, setBotStats] = useState({});
  const [statsLoading, setStatsLoading] = useState(false);
  const [dealTrades, setDealTrades] = useState([]);
  const [dealTradesLoading, setDealTradesLoading] = useState(false);
  const [openDealTradesModal, setOpenDealTradesModal] = useState(false);
  const [selectedDealId, setSelectedDealId] = useState(null);
  const [dealActionLoading, setDealActionLoading] = useState({
    id: null,
    type: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [activeDeals, setActiveDeals] = useState([]);
  const [openTrade, setOpenTrade] = useState(false);

  const getDeals = async () => {
    if (!botId) return;

    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-deals`;
      const payload = { bot_id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setActiveDeals(Array.isArray(result.result) ? result.result : []);
      } else {
        setActiveDeals([]);
      }
    } catch (err) {
      setActiveDeals([]);
    } finally {
      setTradeLoading(false);
    }
  };

  useEffect(() => {
    if (!botId) {
      navigate("/bot");
    }
  }, [botId, navigate]);

  useEffect(() => {
    getDeals();
  }, [botId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const activePaginated = activeDeals.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const getBotDetails = async () => {
    if (!botId) {
      toast.error("Bot ID is required");
      navigate("/bot");
      return;
    }

    try {
      setBotLoading(true);
      const url = `${consts.BackendUrl}/bots/get-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success || result?.id) {
        const botData = result.success ? result.result : result;
        setBotDetails(botData);
        setBotEnabled(botData.is_enabled || false);
      } else {
      }
    } catch (err) {
    } finally {
      setBotLoading(false);
    }
  };

  const getBotStats = async () => {
    if (!botId) return;

    try {
      setStatsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-bot-stats`;
      const payload = { bot_id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setBotStats(result.result || {});
      } else {
      }
    } catch (err) {
    } finally {
      setStatsLoading(false);
    }
  };

  const handleToggleBotStatus = async (isEnabled) => {
    try {
      setToggleLoading(true);
      const url = `${consts.BackendUrl}/bots/enable-bot`;
      const payload = {
        id: botId,
        type: isEnabled ? "enable" : "disable",
      };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(
          result?.message ||
            `Bot ${isEnabled ? "enabled" : "disabled"} successfully`,
        );
        // Refresh bot details and stats after toggle
        await getBotDetails();
        await getBotStats();
      } else {
        setBotEnabled(!isEnabled);
        toast.error(result?.message || "Failed to toggle bot status");
      }
    } catch (err) {
      setBotEnabled(!isEnabled);
      toast.error(err?.message || "Cannot toggle bot status");
    } finally {
      setToggleLoading(false);
    }
  };

  const handleSwitchChange = (e) => {
    const newStatus = e.target.checked;
    setBotEnabled(newStatus);
    handleToggleBotStatus(newStatus);
  };

  const getDealTrades = async (dealId) => {
    if (!dealId) return;

    try {
      setDealTradesLoading(true);
      const url = `${consts.BackendUrl}/bots/get-deal-trades`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setDealTrades(Array.isArray(result.result) ? result.result : []);
      } else {
        setDealTrades([]);
        toast.error(result?.message || "Failed to fetch deal trades");
      }
    } catch (err) {
      setDealTrades([]);
      toast.error(err?.message || "Cannot fetch deal trades");
    } finally {
      setDealTradesLoading(false);
    }
  };

  const handleViewDealTrades = (dealId) => {
    setSelectedDealId(dealId);
    setOpenDealTradesModal(true);
    getDealTrades(dealId);
  };

  const handleCancelDeal = async (dealId) => {
    if (!dealId) return;

    try {
      setDealActionLoading({ id: dealId, type: "cancel" });
      const url = `${consts.BackendUrl}/bots/cancel-deal`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Deal cancelled successfully");
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to cancel deal");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot cancel deal");
    } finally {
      setDealActionLoading({ id: null, type: null });
    }
  };

  const handleCloseDealAtMarket = async (dealId) => {
    if (!dealId) return;

    try {
      setDealActionLoading({ id: dealId, type: "close" });
      const url = `${consts.BackendUrl}/bots/close-deal-at-market`;
      const payload = { deal_id: dealId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Deal closed at market successfully");
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to close deal");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot close deal");
    } finally {
      setDealActionLoading({ id: null, type: null });
    }
  };

  const handleCloseBot = async () => {
    try {
      setCloseLoading(true);
      const url = `${consts.BackendUrl}/bots/close-bot-at-market`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(
          result?.message || "All deals closed at market price successfully",
        );
        setOpenCloseModal(false);
        // Refresh bot details and stats
        await getBotDetails();
        await getBotStats();
      } else {
        toast.error(result?.message || "Failed to close bot deals");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot close bot deals");
    } finally {
      setCloseLoading(false);
    }
  };

  const handleCancelBot = async () => {
    try {
      setCancelLoading(true);
      const url = `${consts.BackendUrl}/bots/cancel-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "All deals cancelled successfully");
        setOpenCancelModal(false);
        // Refresh bot details and stats
        await getBotDetails();
        await getBotStats();
      } else {
        toast.error(result?.message || "Failed to cancel bot");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot cancel bot");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleTriggerManualBot = async () => {
    if (!botId) {
      toast.error("Bot ID is required");
      return;
    }

    try {
      setTriggerLoading(true);
      const url = `${consts.BackendUrl}/bots/trigger-manual-dca-bot`;
      const payload = { id: botId };

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Bot triggered successfully");
        // Refresh bot details and deals
        await getBotDetails();
        await getBotStats();
        await getDeals();
      } else {
        toast.error(result?.message || "Failed to trigger bot");
      }
    } catch (err) {
      toast.error(err?.message || "Cannot trigger bot");
    } finally {
      setTriggerLoading(false);
    }
  };

  useEffect(() => {
    getBotDetails();
    getBotStats();
  }, [botId]);

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          {botLoading ? (
            <div
              className="bot_container contain-width mb-20"
              style={{
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Loader />
            </div>
          ) : (
            <div className="bot_container contain-width mb-20">
              <Grid container spacing={2}>
                {/* Row 1 - Basic Information */}
                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Bot Name</h4>
                    <div>{botDetails?.name || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Pairs</h4>
                    <div>
                      {Array.isArray(botDetails?.pairs)
                        ? botDetails.pairs.join(", ")
                        : botDetails?.pairs || "-"}
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Volume</h4>
                    <div>{botDetails?.base_order_volume || "-"}</div>
                  </div>
                </Grid>

                {/* Row 2 - Profit Settings */}
                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Take Profit Type</h4>
                    <div>{botDetails?.take_profit_type || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Risk Percentage</h4>
                    <div>{botDetails?.risk_reduction_percentage || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Safety Order Percentage</h4>
                    <div>{botDetails?.safety_order_step_percentage || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Safety Order Volume</h4>
                    <div>{botDetails?.safety_order_volume || "-"}</div>
                  </div>
                </Grid>

                {/* Row 3 - Advanced Settings */}
                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Max Safety Order</h4>
                    <div>{botDetails?.max_safety_orders || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Leverage Type</h4>
                    <div>{botDetails?.leverage_type || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Min Price</h4>
                    <div>{botDetails?.min_price || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Max Price</h4>
                    <div>{botDetails?.max_price || "-"}</div>
                  </div>
                </Grid>

                {/* Row 4 - Additional Info */}
                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Profit Currency</h4>
                    <div>{botDetails?.profit_currency || "-"}</div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Start Order Type</h4>
                    <div>
                      {botDetails?.start_order_type
                        ? botDetails.start_order_type === "signal"
                          ? "Trading View Signal"
                          : botDetails.start_order_type
                              .charAt(0)
                              .toUpperCase() +
                            botDetails.start_order_type.slice(1)
                        : "-"}
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Bot ID</h4>
                    <div
                      style={{
                        wordBreak: "break-all",
                        fontFamily: "monospace",
                        fontSize: "14px",
                      }}
                    >
                      {botDetails?.id || botDetails?.bot_id || "-"}
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <div className="display-2">
                    <h4>Account ID</h4>
                    <div
                      style={{
                        wordBreak: "break-all",
                        fontFamily: "monospace",
                        fontSize: "14px",
                      }}
                    >
                      {botDetails?.account_id || "-"}
                    </div>
                  </div>
                </Grid>

                {(botDetails?.start_order_type === "signal" ||
                  (Array.isArray(botDetails?.strategy_list) &&
                    botDetails.strategy_list.some(
                      (s) => s.strategy === "tv_custom_signal",
                    ))) && (
                  <>
                    <Grid item xs={12}>
                      <div className="display-2">
                        <h4>Webhook URL for TradingView</h4>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <div>
                            {`${consts.BackendUrl}/bots/trigger-trading-view`}
                          </div>

                          <ContentCopyIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const webhookUrl = `${consts.BackendUrl}/bots/trigger-trading-view`;
                              navigator.clipboard.writeText(webhookUrl);
                              toast.success("Webhook URL copied to clipboard!");
                            }}
                          />
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="display-2">
                        <h4>TradingView Alert Message (JSON Payload)</h4>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              wordBreak: "break-all",
                              fontFamily: "monospace",
                              fontSize: "12px",
                              padding: "10px",
                              borderRadius: "4px",
                              whiteSpace: "pre-wrap",
                              flex: 1,
                            }}
                          >
                            {JSON.stringify(
                              {
                                account_id: botDetails?.account_id || 0,
                                bot_id:
                                  botDetails?.id || botDetails?.bot_id || 0,
                              },
                              null,
                              2,
                            )}
                          </div>

                          <ContentCopyIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const payload = JSON.stringify(
                                {
                                  account_id: botDetails?.account_id || 0,
                                  bot_id:
                                    botDetails?.id || botDetails?.bot_id || 0,
                                },
                                null,
                                2,
                              );
                              navigator.clipboard.writeText(payload);
                              toast.success("Payload copied to clipboard!");
                            }}
                          />
                        </div>
                      </div>
                    </Grid>
                  </>
                )}

                {/* Controls Row */}
                <Grid item xs={12}>
                  <div
                    className="flexend"
                    style={{ gap: "10px", marginTop: "10px" }}
                  >
                    <div className="bot_comman_btn">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={botEnabled}
                            onChange={handleSwitchChange}
                            color="primary"
                            disabled={toggleLoading}
                          />
                        }
                        label={botEnabled ? "Enabled" : "Disabled"}
                      />
                    </div>

                    {/* Show Trigger Button for Manual Bots */}
                    {botDetails?.start_order_type === "manual" && (
                      <div className="bot_comman_btn">
                        <Button
                          onClick={handleTriggerManualBot}
                          disabled={
                            triggerLoading || !botDetails?.id || !botEnabled
                          }
                          variant="contained"
                          color="success"
                        >
                          {triggerLoading ? "Triggering..." : "Start New Deal"}
                        </Button>
                      </div>
                    )}

                    <div className="bot_comman_btn">
                      <Button
                        onClick={() => setOpenCloseModal(true)}
                        disabled={closeLoading || !botDetails?.id}
                      >
                        Close Deals at Market Price
                      </Button>
                    </div>

                    <div className="bot_comman_btn">
                      <Button
                        onClick={() => setOpenCancelModal(true)}
                        disabled={cancelLoading || !botDetails?.id}
                      >
                        Cancel All Deals
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-20">
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flexend">
                        <div className='bot_comman_btn' >
                            <Button
                            >
                               Enable
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Disable
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Close Bot
                            </Button>
                        </div>
                        <div className='bot_comman_btn' >
                            <Button
                            >
                                Cancel Bot
                            </Button>
                        </div>
                    </div>
                </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full mt-20"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Overall USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${botStats?.profits_in_usd?.overall_usd_profit?.toFixed(2) || "0.00"} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Today USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${botStats?.profits_in_usd?.today_usd_profit?.toFixed(2) || "0.00"} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Active Deals USDT Profit</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${botStats?.profits_in_usd?.active_deals_usd_profit?.toFixed(2) || "0.00"} USDT`}
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={3}
          xl={3}
          className="grid-bot-full"
        >
          <div className="bot_dash flex-1 just-center p-2 mt-20">
            <div>Funds Locked</div>
            <div>
              {statsLoading
                ? "Loading..."
                : `${botStats?.profits_in_usd?.funds_locked_in_active_deals?.toFixed(2) || "0.00"} USDT`}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              <div className="h_flx">
                <h3>Active Trade</h3>
              </div>

              <TableContainer sx={{ marginBottom: "10px" }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Created At</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Current Price</TableCell>
                      <TableCell>Bought Avg Price</TableCell>
                      <TableCell>Take Profit Price</TableCell>
                      <TableCell>Actual USD Profit</TableCell>
                      <TableCell>Deal ID</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tradeLoading ? (
                      <TableRow>
                        <TableCell colSpan={9}>
                          <div className="inline-loader">
                            <Loader />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : activePaginated?.length > 0 ? (
                      activePaginated.map((row, i) => (
                        <TableRow key={i} className="tr_row">
                          <TableCell>{row.created_at || "-"}</TableCell>
                          <TableCell>{row.pair || "-"}</TableCell>
                          <TableCell>
                            {row.localized_status || row.status || "-"}
                          </TableCell>
                          <TableCell>{row.current_price || "-"}</TableCell>
                          <TableCell>
                            {row.bought_average_price || "-"}
                          </TableCell>
                          <TableCell>{row.take_profit_price || "-"}</TableCell>
                          <TableCell>{row.actual_usd_profit || "-"}</TableCell>
                          <TableCell>{row.id || "-"}</TableCell>
                          <TableCell style={{ display: "flex", gap: "10px" }}>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleViewDealTrades(row.id)}
                              disabled={
                                dealActionLoading.id === row.id || tradeLoading
                              }
                            >
                              View
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleCancelDeal(row.id)}
                              disabled={
                                dealActionLoading.id === row.id || tradeLoading
                              }
                            >
                              {dealActionLoading.id === row.id &&
                              dealActionLoading.type === "cancel"
                                ? "Cancelling..."
                                : "Cancel"}
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleCloseDealAtMarket(row.id)}
                              disabled={
                                dealActionLoading.id === row.id || tradeLoading
                              }
                            >
                              {dealActionLoading.id === row.id &&
                              dealActionLoading.type === "close"
                                ? "Closing..."
                                : "Close at Market"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No Active Trades
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={activeDeals.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Close Bot Confirmation Modal */}
      <Modal
        open={openCloseModal}
        onClose={() => !closeLoading && setOpenCloseModal(false)}
      >
        <Box sx={style}>
          <div className="p-20">
            <h3 className="mb-20">Close Bot at Market</h3>
            <p>
              Are you sure you want to close all deals at market price? This
              will disable the bot.
            </p>
          </div>

          <div className="display-2" style={{ gap: "10px" }}>
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => setOpenCloseModal(false)}
                disabled={closeLoading}
              >
                Cancel
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCloseBot}
                disabled={closeLoading}
              >
                {closeLoading ? "Closing..." : "Close Bot"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Cancel Bot Confirmation Modal */}
      <Modal
        open={openCancelModal}
        onClose={() => !cancelLoading && setOpenCancelModal(false)}
      >
        <Box sx={style}>
          <div className="p-20">
            <h3 className="mb-20">Cancel Bot</h3>
            <p>
              Are you sure you want to cancel all deals? This will disable the
              bot.
            </p>
          </div>

          <div className="display-2" style={{ gap: "10px" }}>
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => setOpenCancelModal(false)}
                disabled={cancelLoading}
              >
                Cancel
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCancelBot}
                disabled={cancelLoading}
              >
                {cancelLoading ? "Cancelling..." : "Cancel Bot"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Deal Trades Modal */}
      <Modal
        open={openDealTradesModal}
        onClose={() => setOpenDealTradesModal(false)}
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Deal Trades</div>
          </div>

          <div style={{ maxHeight: "350px", overflow: "auto" }}>
            <TableContainer sx={{ marginBottom: "10px" }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Deal Order Type</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Rate</TableCell>
                    <TableCell>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dealTradesLoading ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <div className="inline-loader">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : dealTrades?.length > 0 ? (
                    dealTrades.map((trade, index) => (
                      <TableRow key={index} className="tr_row">
                        <TableCell>{trade.order_id || "-"}</TableCell>
                        <TableCell>{trade.order_type || "-"}</TableCell>
                        <TableCell>{trade.deal_order_type || "-"}</TableCell>
                        <TableCell>{trade.status_string || "-"}</TableCell>
                        <TableCell>{trade.created_at || "-"}</TableCell>
                        <TableCell>{trade.quantity || "-"}</TableCell>
                        <TableCell>{trade.rate || "-"}</TableCell>
                        <TableCell>{trade.total || "-"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Trades Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              onClick={() => setOpenDealTradesModal(false)}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default DCAbottrade;
